<script>
import Layout from '@layouts/main'
import LoginSidebar from '@components/login-sidebar'
import { authMethods } from '@state/helpers'

export default {
  components: { Layout, LoginSidebar },
  metaInfo: {
    title: 'ForgotPassword',
    meta: [{ name: 'description', content: 'ForgotPassword' }],
  },
  data() {
    return {
      isWorking: false,
      responseMessage: null,
      emailAddress: null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
    }
  },
  methods: {
    ...authMethods,
    tryForgotPassword() {
      this.responseMessage = null
      this.isWorking = true

      this.forgotPassword({ emailAddress: this.emailAddress })
        .then(response => {
          this.isWorking = false
          this.responseMessage = `Password reset email sent to ${
            this.emailAddress
          }`
        })
        .catch(error => {
          this.isWorking = false
          if (typeof error === 'string') {
            this.responseMessage = error
          } else if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            this.responseMessage = error.response.data.error
          } else {
            this.responseMessage =
              'An error occurred sending password reset email'
          }
        })
    },
  },
}
</script>

<template>
  <Layout row class="pa-0">
    <LoginSidebar />

    <v-flex xs7 class="main">
      <v-layout fill-height justify-center>
        <v-flex sm7 class="form">
          <h2>Forgot Password</h2>
          <p>
            Enter the email address associated with your account to receive a
            password reset link.
          </p>
          <v-form
            ref="form"
            class="form"
            lazy-validation
            @submit.prevent="tryForgotPassword"
          >
            <v-text-field
              v-model="emailAddress"
              name="emailAddress"
              :rules="emailRules"
              type="email"
              placeholder="Email Address"
              required
            ></v-text-field>
            <v-btn
              depressed
              block
              primary
              class="btn-blue"
              :disabled="isWorking"
              type="submit"
            >
              <BaseIcon v-if="isWorking" name="sync" spin />
              <span v-else>Send Password Reset Email</span>
            </v-btn>
            <p v-if="responseMessage">{{ responseMessage }}</p>
          </v-form>

          <hr />

          <v-btn outline block class="btn-blue-outline" :to="{ name: 'login' }">
            <span>Back to Login</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </Layout>
</template>

<style lang="scss">
@import '@design';
</style>
